export enum PatchContentViews {
    S_TIER = "S TIER",
    STATS = "STATS",
    COMPS = "COMPS",
}

export enum Lane {
    TOP = "Top",
    JUNGLE = "Jungle",
    MID = "Mid",
    BOTTOM = "Bottom",
    SUPPORT = "Support",
}
export const ALL_LANES: Lane[] = [Lane.TOP, Lane.JUNGLE, Lane.MID, Lane.BOTTOM, Lane.SUPPORT];

export enum ScalingPhase {
    EARLY = "Early",
    MID = "Mid",
    LATE = "Late"
}

export const ALL_SCALING: ScalingPhase[] = [ScalingPhase.EARLY, ScalingPhase.MID, ScalingPhase.LATE];
